import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';
import { vMaska } from 'maska';
import PortalVue from 'portal-vue';
import VueTour from 'vue-tour';
import AmountInput from '@/views/dashboard/components/AmountInput';
import { NotificationService } from '@/services/notification-service';
import Particles from '@tsparticles/vue2';
import { loadSlim } from '@tsparticles/slim';

import App from './App';
import './registerServiceWorker';
import router from './router';
import store from './store';
import { i18n } from './i18n';
import vuetify from './plugins/vuetify';

import './plugins/moment';
import configureModules from './config';

import('vue-tour/dist/vue-tour.css');

Vue.use(Particles, {
  init: async (engine) => {
    await loadSlim(engine);
  },
});

Vue.directive('mask', VueMaskDirective);
Vue.directive('maska', vMaska);
Vue.directive('custom-click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
Vue.use(PortalVue);
Vue.use(VueTour);

Vue.component('AmountInput', AmountInput);

Vue.config.productionTip = false;

configureModules();

Vue.prototype.$notify = NotificationService;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
